import React from 'react';
import PropTypes from 'prop-types';
import { DeprecatedStatePill } from '@common/components';
import { FontSizes } from 'works/legacy/lib/style-helper';

const STATUS_COLOR = {
  pending: 'elm-darker',
};

/**
 * Thin wrapper around `DeprecatedStatePill` for institution rate-card status labels.
 *
 * @deprecated Prefer `StatusPill` from `@common/components/status-pill` for new UI instead of this component.
 */
export const DeprecatedStatusPill = ({ status }) => (
  <DeprecatedStatePill
    color={STATUS_COLOR[status]}
    fontSize={FontSizes.small}
    capitalized
  >
    {status.toLowerCase()}
  </DeprecatedStatePill>
);

DeprecatedStatusPill.propTypes = {
  status: PropTypes.string.isRequired,
};
